<template>
	<div class="layout">
		<ihead :checkindex='checkindex'></ihead>
		<mu-carousel class="my-carousel" transition="fade">
			<mu-carousel-item v-for="item in banners" :key="item.id">
				<img :src="item.image_url">
			</mu-carousel-item>
		</mu-carousel>
		<square></square>
		<mu-flex class="about mt30" justify-content="start" align-self="center">
			<div class="i-item">
				<img class="image-column" src="../assets/fluid-image-1.jpg" alt="">
			</div>
			<div class="i-item">
				<div class="item-content">
					<h2 class="h2title">{{info.title}}</h2>
					<p class="descript">高校、科研院、企业加入平台</p>
					<div class="text" v-html="info.description"></div>
					<mu-button class="a-btu" flat @click="toAbout(info.id)">了解详情</mu-button>
					<mu-button class="a-btu" color="secondary">加入我们</mu-button>
				</div>
			</div>
		</mu-flex>
		<pcard class="project" :list="projects"></pcard>
		<div class="team team-box">
			<mu-container>
				<mu-tabs class="teamtabs" :value.sync="active" inverse color="#5e5e5e" indicator-color="#932120" text-color="rgba(0, 0, 0, .54)" center>
					<mu-tab v-for="(item, index) in organizationList" :key="index">{{item.title}}</mu-tab>
				</mu-tabs>
				<div v-for="(item, index) in organizationList" :key="index">
					<ul class="project-item" v-if="active === index">
						<li v-for="(subteam, subindex) in item.institution" :key="subindex" v-if="subindex < 4">
							<router-link :to="{path:'/team'}">
								<img class="team-img" :src="subteam.picture.path" alt="">
								<div class="overlay-box">
									<div class="overlay-tit">{{subteam.name}}</div>
									<div class="overlay-content">
										{{subteam.synopsis}}
									</div>
								</div>
							</router-link>
						</li>
					</ul>
				</div>
			</mu-container>
		</div>
		<div class="news">
			<mu-container>
				<h2 class="h2title">综合资讯</h2>
				<p class="descript">高校、科研院、企业加入平台</p>
				<mu-row class="mt30" gutter>
					<mu-col span="5" class="news-descrip">
						<router-link v-for="(item, index) in news" :key="index" :to="{path:'/informationdetails', query: {id: item.id, cid: item.category_id, mainid: item.navInfo.pid, subid: item.navInfo.id}}">
						<mu-card v-if="index === 0">
							<mu-card-media>
								<img :src="item.img">
							</mu-card-media>
							<mu-card-title :title="item.title" :sub-title="item.time"></mu-card-title>
							<mu-card-text>{{item.description}}</mu-card-text>
						</mu-card>
						</router-link>
					</mu-col>
					<mu-col span="7">
						<div v-for="(item, index) in news" :key="index">
						<mu-list v-if="index > 0" textline="three-line">
							<mu-list-item avatar button :ripple="false" :to="{path:'/informationdetails', query: {id: item.id, cid: item.category_id, mainid: item.navInfo.pid, subid: item.navInfo.id}}">
								<mu-list-item-action>
									<mu-avatar>
										<img :src="item.img">
									</mu-avatar>
								</mu-list-item-action>
								<mu-list-item-content>
									<mu-list-item-title>{{item.title}}</mu-list-item-title>
									<mu-list-item-sub-title>
										<p class="time">{{item.time}}</p>
										<p class="cont">{{item.description}}</p>
									</mu-list-item-sub-title>
								</mu-list-item-content>
								<mu-list-item-action>
									<i class="iconfont icon-chakangengduoshuju"></i>
								</mu-list-item-action>
							</mu-list-item>
						</mu-list>
						</div>
					</mu-col>
				</mu-row>
			</mu-container>
		</div>
    <Footer class="ifoot"><ifoot></ifoot></Footer>
	<returntop class="return-top"></returntop>
  </div>
</template>

<script>
import '../assets/css/team.css'
import ifoot from '@/components/ifoot.vue'
import ihead from '@/components/ihead.vue'
import square from '@/components/square.vue'
import pcard from '@/components/pcard.vue'
import returntop from '@/components/returntop'
export default {
  name: 'index',
	components: {
		ihead, ifoot, square, pcard,returntop
	},
	data() {
		return {
			checkindex:0,
			swiperOptions: {
				pagination: {
					el: '.swiper-pagination'
				}
			},
			banners: [],
			active: 0,
			info: {},
			projects: [],
			organizationList:[],
			news: []
    }
	},
	created: function () {
		this.getBanner()
		this.getAbout()
		this.getOrganization()
		this.getProject()
		this.getNews()
	},
	computed: {
		swiper() {
			return this.$refs.mySwiper.$swiper
		},
		teams() {
			return (size) => {
				let newTeam = Array
				this.organizationList.forEach(item => {
					item.institution.forEach((subitem, index) => {
						// console.log(index)
					})
				})
			}
		}
  },
  mounted() {
    // console.log('Current Swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
	},
	methods: {
		getBanner () {
		  this.$get('/ad/index').then(res => {
				if (res.code === 0) {
						let data = res.data
					if (data){
						this.banners = data
					}
				} else {
					// console.log(res.message)
				}
			})
		},
		getAbout () {
		  this.$get('/article/get-article-detail', {
				id: 21
			}).then(res => {
				if (res.code === 0) {
						let data = res.data
					if (data){
						this.info = data
					}
					} else {
						// console.log(res.message)
					}
			})
		},
		getOrganization () {
		  this.$get('institution/get-institution-list', {
				page: 1,
				offset: 50
			}).then(res => {
				if (res.code === 0) {
						let data = res.data
					if (data){
						this.organizationList = data
					}
					} else {
						// console.log(res.message)
					}
			})
		},
		getProject () {
		  this.$get('project/get-project-list', {
				page: 1,
				offset: 3
			}).then(res => {
				if (res.code === 0) {
						let data = res.data
					if (data) {
						data.forEach(ref => {
							if (ref.picture != null && typeof(ref.picture) != 'undefined') {
								ref.pic = ref.picture.path
							} else {
								ref.pic = ''
							}
						})
						this.projects = data
					}
				} else {
					// console.log(res.message)
				}
			})
		},
		getNews () {
		  this.$get('article/get-article-list', {
				page: 1,
				offset: 6
			}).then(res => {
				if (res.code === 0) {
					let data = res.data.data
					if (data){
						data.forEach(ref => {
							ref.time = this.$getData(ref.create_time)
							if (ref.picture != null && typeof(ref.picture) != 'undefined') {
								ref.img = ref.picture.path
							} else {
								ref.img = ''
							}
						})
						this.news = data						
					}
					} else {
						// console.log(res.message)
					}
			})
		},
		toAbout (id) {
			this.$router.push({name: 'introduction', query: {id: id}})
		}
	}
}
</script>

<style scoped>
.banner{
	 min-height: 380px;
	 margin-top: 90px;
 }
 .about, .team{
	 width: 100%;
	 background: #ffffff;
 }
 .team, .project{
	 padding: 0 0 50px 0;
 }
.i-item{
	width: 50%;
	display: flex;
	align-self: center;
}
.item-content {
	margin-left: 30px;
	width: 600px;
}
.item-content .text{
	margin-top: 20px;
	text-align: left;
}
.item-content .a-btu{
	margin: 10px 15px;
}
.i-item .image-column{
	width: 100%;
	height: 100%;
}
.teamtabs >>> .mu-tab{
	font-size: 24px;
	color: #5e5e5e;
}
.teamtabs >>> .mu-tab-active{
	color: #932120;
}
.team >>> .mu-tabs-inverse{
	background: transparent;
}
.tabactive{
	color: #932120;
}
.project-item{
	height: 210px;
}
/* .news >>> .mu-item-action{
	min-width: 126px;
} */
.icon-chakangengduoshuju{
	color: #d3d3d3;
}
.news >>> a:hover .icon-chakangengduoshuju{
  color: #5e5e5e;
}
.layout >>> .my-carousel{
	height: 360px;
	margin-top: 90px;
}
.team-img{
	height: 320px;
}
@media screen and ( max-width: 768px){
  .team-box ul li .team-img{
    width: 100%;
    height: 100px;
  }
  .team-box{
	  padding: 50px 0 0 0;
  }
  .news-descrip{
	  display: none;
  }
  .mu-list {
	  width: 180%;
  } 
  .i-item{
	  width: 100%;
  }
  .item-content{
	  margin: 0 15px;
  }
  .i-item .image-column{
	  display: none;
  } 
  .layout >>> .my-carousel{
	  height: 240px;
  }
}
@media screen and ( max-width: 320px) {	
			
}

</style>